// @core/api/endpoints/project/get_item_by_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get item by key
 * Resolves a project item by its human-readable key (e.g., MP-123). Used for git commit linking, search, and cross-referencing in chats and documents.
 */
export async function GetItemByKey(
  project_id: string,
  item_key: string,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items/by-key/:item_key`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':item_key', encodeURIComponent(item_key));
  const requestOptions = options;
  return client.get<ItemResponse>(requestPath, { ...requestOptions });
}
